import React, { useEffect, useRef, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import DocumentPrint from '../../components/print/DocumentPrint';
import { fetchDeliveryNoteGrouped, setSelected, clearCurrentDeliveryNote } from '../../store/modules/deliverynote/deliverynoteActions';
import 'react-toastify/dist/ReactToastify.css';

const DeliverynotesView = () => {
    const deliverynoteState = useSelector(state => state.deliverynote);
    const dispatch = useDispatch();
    const { id } = useParams();
    const isInitialized = useRef(false);
    const [isLoading, setIsLoading] = useState(false);

    const actions = {
        fetchSingle: (id) => dispatch(fetchDeliveryNoteGrouped(id)),
        setItemsSelected: (selectedRows) => dispatch(setSelected(selectedRows)),
        clearCurrent: () => dispatch(clearCurrentDeliveryNote())
    };

    // Fetch function with proper dependencies using actions
    const fetchData = useCallback(async (id) => {
        try {
            setIsLoading(true);
            const data = await actions.fetchSingle(id);
            if(data && data.items) {
                const selectedIds = data.items.map(item => item?.item?.id);
                await actions.setItemsSelected({
                    key: 'itemIds',
                    data: selectedIds
                });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Initial data fetch
    useEffect(() => {
        if (!isInitialized.current) {
            isInitialized.current = true;
            fetchData(id);
        }
    }, [fetchData, id]);

    // Cleanup when component unmounts
    useEffect(() => {
        return () => {
            actions.clearCurrent();
        };
    }, []);

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <DocumentPrint
                            data={deliverynoteState.current}
                            isLoading={isLoading}
                            documentType="deliveryNote"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default DeliverynotesView;

